import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';

import { ciamAuth } from "./configs/oktaConfigs"; //default auth
import Routes from './AppRoutes';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { UserProvider } from './contexts/UserContext';
import { useAxiosInterceptors } from './hooks/useAxiosInterceptors';

// Component to initialize axios interceptors
const AppContent: React.FC = () => {
    useAxiosInterceptors();
    return <Routes />;
};

function App() {
    
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);

    // Allow for "stale" navigate references since originalUri will be an absolute URL.
    const restoreOriginalUri = useCallback((_:any, originalUri = '/') => {
        const url = toRelativeUrl(originalUri, globalThis.location.origin);
        navigateRef.current(url);
    }, []);

    useEffect(() => {
        //cleanup
        return () => {
            ciamAuth.options.restoreOriginalUri = undefined;
        }
    }, []);
    
    return (
        <div className="App">
            <SnackbarProvider>
                <Security oktaAuth={ciamAuth} restoreOriginalUri={restoreOriginalUri}>
                    <UserProvider>
                        <AppContent />
                    </UserProvider>
                </Security>
            </SnackbarProvider>
        </div>
    );
}

export default App;
